import styled from "styled-components";
import theme from "../../../styles/theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100vw;

  .top {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${theme.colors.brown.secundary};

    .logo {
      width: 500px;
      margin-bottom: -4vh;

      @media ${theme.devices.tablet} {
        width: 200px;
        margin-left: 7vw;
      }
    }

    .company {
      background-color: ${theme.colors.brown.primary};
      padding: 10px 3vw;
      border-top-left-radius: 25px;
      border-top-right-radius: 25px;
      margin-top: 4vh;

      @media ${theme.devices.tablet} {
        padding-inline: 10vw;
      }

      .lbl {
        font-weight: bolder;
        font-size: ${theme.fontSize.md};
        color: white;

        @media ${theme.devices.tablet} {
          font-size: ${theme.fontSize.mm};
        }
      }
    }
  }

  .middle {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${theme.colors.brown.capivaraLightAux};

    .title {
      font-weight: bolder;
      font-size: ${theme.fontSize.lg};
      margin-top: 3vh;
      color: ${theme.colors.brown.primary};
      font-family: sans-serif;

      @media ${theme.devices.tablet} {
        font-size: ${theme.fontSize.md2};
      }
    }
  }

  .bottom {
    display: flex;
    flex-direction: column;
    background: #faf4eb;
    height: 100%;
  }
`;

export const HomeForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const BtnContainer = styled.div`
  margin-top: 3vh;
  margin-bottom: 2vh;
`;

export const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .data-container {
    display: flex;
    flex-direction: column;
    text-align: center;
    background-color: #fdf8f0;
    color: ${theme.colors.brown.primary};
    font-family: sans-serif;
    margin-top: 3vh;
    align-self: center;
    border-radius: 15px;
    padding-bottom: 4vh;
    margin-inline: 20vw;

    @media ${theme.devices.tablet} {
      margin-inline: 5vw;
    }

    .status {
      font-size: ${theme.fontSize.md2};
      font-weight: bold;

      @media ${theme.devices.tablet} {
        font-size: ${theme.fontSize.mm};
      }
    }

    .detail {
      font-size: ${theme.fontSize.md};

      @media ${theme.devices.tablet} {
        font-size: ${theme.fontSize.mm};
      }
    }

    .response-data-container {
      display: flex;
      flex-direction: column;
      row-gap: 0.5vh;
      margin: 3vh 0;
    }
  }

  .result {
    color: ${theme.colors.brown.primary};
    display: flex;
    flex-direction: column;
    margin-top: 3vh;
    align-self: center;
    margin-inline: 2vw;
    text-align: justify;

    .lbl {
      font-family: sans-serif;
      font-size: ${theme.fontSize.md2};
      font-weight: bold;
      text-align: center;

      @media ${theme.devices.tablet} {
        font-size: ${theme.fontSize.mm};
      }
    }
  }

  .btn-container {
    display: flex;
    align-self: center;
  }
`;
export const ColumnForm = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 2vw;
  margin-bottom: 3vh;
  align-self: center;
  margin-top: 2vh;
  align-items: end;
  width: 100%;
  flex: 10;
  .input {
    flex: 5;
    @media ${theme.devices.tablet} {
      width: 100%;
      margin-bottom: 2vh;
    }
  }
  .btn {
    flex: 1;
    @media ${theme.devices.tablet} {
      width: 100%;
    }
  }
  @media ${theme.devices.tablet} {
    flex-direction: column;
    align-items: center;
  }
`;
export const ColumnFormAux = styled.div`
  display: flex;
  flex-direction: column;
  color: black;
  align-items: center;
  margin-bottom: 3vh;
`;
export const ContainerData = styled.div<{ disabled?: boolean }>`
  background: ${(props) =>
    props.disabled
      ? "linear-gradient(to top right,rgba(168, 136, 77, 0.3) 85%,rgba(200, 160, 94, 0.3) 50%);"
      : "linear-gradient(to top right, #a9884d 85%, #c8a05e 50%)"};
  display: flex;
  position: relative;
  flex-direction: column;
  text-align: center;
  background-color: ${theme.colors.palete.brownLighter};
  border-radius: 5px;
  width: 95%;
  padding: 20px;
  place-self: center;
  height: fit-content;
  margin-bottom: 2vh;
  @media ${theme.devices.tablet} {
    width: 90%;
    padding: 10px;
  }
`;
export const SectionTitle = styled.span`
  font-size: ${theme.fontSize.md};
  font-weight: bold;
  color: ${theme.colors.brown.primary};
  font-family: sans-serif;
  text-align: left;
`;
export const SectionDescription = styled.p`
  font-size: ${theme.fontSize.mm};
  color: ${theme.colors.brown.primary};
  font-family: sans-serif;
  text-align: left;
  margin-top: 1vh;
`;
export const TitleToggleRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2vh;
  .toggle-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 1vw;
  }
`;